import { createContext } from "react";

const MilestonesData = createContext({});
export default MilestonesData;
